import { render, staticRenderFns } from "./fpsChart.vue?vue&type=template&id=097f60bc&scoped=true"
import script from "./fpsChart.vue?vue&type=script&lang=js"
export * from "./fpsChart.vue?vue&type=script&lang=js"
import style0 from "./fpsChart.vue?vue&type=style&index=0&id=097f60bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097f60bc",
  null
  
)

export default component.exports